import styled from "styled-components";

export const StyledContainer = styled.div<{browserType: boolean}>`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	row-gap: 30px;
	h2 {
		font-family: 'Suit extra bold';
		font-size: 20px;
		font-weight: 800;
		line-height: 22px;
		color: rgba(38, 38, 38, 1);
		margin-bottom: 10px;
		font-weight: ${(props) => props.browserType ? 600 : 800};
	}
	h3 {
		font-family: 'Suit medium';
		font-size: 26px;
		font-weight: ${(props) => props.browserType ? 400 : 500};
		line-height: 22px;
		color: rgba(38, 38, 38, 1);
	}
	button{
		width: 340px;
		height: 52px;
		border: 1px solid rgba(90, 30, 219, 1);
		border-radius: 5px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-family: 'Suit medium';
		font-size: 16px;
		font-weight: 700;
		line-height: 22px;
		color: rgba(90, 30, 219, 1);
		margin-top: 20px;
		&:hover {
			background-color: rgba(90, 30, 219, 1);
			color: rgba(255, 255, 255, 1);
			border: none;
		}
		${({ theme }) =>
    theme.media.mobile(
      `
				width: 240px;
    	`,
    )}
	}
`

export const StylledIcon = styled.div`
	width: 135px;
	height: 135px;
	background-color: rgba(237, 229, 255, 1);
	border-radius: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
	svg{
		width: 100%;
	}
`